export default __webpack_public_path__ + "svg/calendar/2025/6/septiembre.svg?eb906394";